import React from 'react';
import Leave_Resign from './Leave_Resign';
import '../../../CommonCSS/SocietyCSS.css';

const Leave_ResignApp = () => {
  return (
    // <div className="App">
    //   <Common_Mst />
    // </div>
    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Leave Application</h5>
          </div>
        </div>
        <Leave_Resign />
      </div>
    </div >
  );
};

export default Leave_ResignApp;
